import { z } from 'zod';

export const distressButtonNotificationMetadataSchema = z.object({
	projectId: z.string(),
	tagId: z.string(),
	name: z.string().optional(),
	floorNick: z.string(),
	areaNick: z.string(),
});

export type IDistressButtonNotificationMetadata = z.infer<typeof distressButtonNotificationMetadataSchema>;
